<template>
  <div id="basic">
    <div class="banner_bar">
      <h3>菜品原料信息</h3>
      <el-form>
        <div class="bottom_center">
          <el-button
            type="primary"
            class="vubutton"
            :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
            @click="onSubmit"
          >+新建</el-button>
        </div>
        <div style="display:flex">
        </div>
      </el-form>

      <el-table
        :fit="false"
        border
        :data="tableData"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="所属分类" width="180">
          <template slot-scope="scope">
            <span>{{ translateCategory(scope.row.category) }}</span>
          </template>
        </el-table-column>
          <el-table-column label="计量单位" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.unit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单价(元)" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.unit_price }} 元</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="mini" @click="getEdit(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog title="详细信息" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="所属分类" :label-width="formLabelWidth">
<!--          <el-input v-model="form.category" autocomplete="off" :disabled="form.getEdit"></el-input>-->
          <el-select v-model="form.category" placeholder="请选择" :disabled="form.getEdit">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计量单位" type="“number”" :label-width="formLabelWidth">
          <el-input v-model="form.unit" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="单价(元)" :label-width="formLabelWidth">
          <el-input v-model="form.unit_price" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="卡洛里" :label-width="formLabelWidth">
          <el-input v-model="form.calorie" autocomplete="off" :disabled="form.getEdit">
<!--            <el-tag type="info" slot="append">C</el-tag>-->
            <el-button slot="append" type="text">C</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="油" :label-width="formLabelWidth">
          <el-input v-model="form.oil" autocomplete="off" :disabled="form.getEdit"><el-button slot="append" type="text">g</el-button></el-input>
        </el-form-item>
        <el-form-item label="盐" :label-width="formLabelWidth">
          <el-input v-model="form.salt" autocomplete="off" :disabled="form.getEdit"><el-button slot="append" type="text">g</el-button></el-input>
        </el-form-item>
        <el-form-item label="糖" :label-width="formLabelWidth" >
          <el-input v-model="form.sugar" autocomplete="off" :disabled="form.getEdit"><el-button slot="append" type="text">g</el-button></el-input>
        </el-form-item>
        <el-form-item label="脂肪" :label-width="formLabelWidth" >
          <el-input v-model="form.fat" autocomplete="off" :disabled="form.getEdit"><el-button slot="append" type="text">g</el-button></el-input>
        </el-form-item>
        <el-form-item label="糖水化合物" :label-width="formLabelWidth">
          <el-input v-model="form.carbohydrate" autocomplete="off" :disabled="form.getEdit"><el-button slot="append" type="text">g</el-button></el-input>
        </el-form-item>
        <el-form-item label="蛋白质" :label-width="formLabelWidth" >
          <el-input v-model="form.protein" autocomplete="off" :disabled="form.getEdit"><el-button slot="append" type="text">g</el-button></el-input>
        </el-form-item>
        <el-form-item label="钠" :label-width="formLabelWidth">
          <el-input v-model="form.na" autocomplete="off" :disabled="form.getEdit"><el-button slot="append" type="text">mg</el-button></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noStatus()">取 消</el-button>
        <el-button type="primary" @click="statusStore()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';
export default {
  data() {
    return {
      platform: '',
      tableData: [],
      datalist: [],
      options:[
        {
          label:'蔬菜',
          value: 'Vegetable'
        },
        {
          label:'干杂',
          value: 'DryMix'
        },
        {
          label:'调料',
          value: 'Dressing'
        },
        {
          label:'冻品',
          value: 'Frozen'
        },
        {
          label:'鲜肉',
          value: 'Meat'
        },
        {
          label:'鱼类海鲜',
          value: 'Fish'
        },
        {
          label:'鲜禽',
          value: 'Bird'
        },
        {
          label:'清洁用品',
          value: 'Clean'
        },
        {
          label:'一次性耗材用品',
          value: 'SingleUse'
        },
        {
          label:'其他日常用品',
          value: 'Other'
        },
      ],
      parentid: null,
      formInline: {
        id: '',
      },
      total: 0,
      page_no: 0,
      dialogFormVisible: false,
      form: {
        name: '',
      },
      formLabelWidth: '120px',
      putStatus: false,
    };
  },
  methods: {
    pageSize(index) {
      this.page_no = index;
      this.getTableData();
    },

    translateCategory(value) {
      for (let option of this.options){
        if (option.value === value) {
          return option.label
        }
      }
      return ''
    },
    // 获取列表
    getTableData() {
      let baseUrl = ''
      if (this.platform === '1') {
         baseUrl =  this.$userList.user_dish_raw_platform
      } else {
        baseUrl = this.$userList.user_dish_raw
      }
      const url = baseUrl + '/' + this.page_no + '/10';

      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.items.map(items => {
            items.created_at = fecha.format(
              new Date(items.created_at),
              'yyyy-MM-dd HH:mm:ss'
            );
            items.updated_at = fecha.format(
              new Date(items.updated_at),
              'yyyy-MM-dd HH:mm:ss'
            );
            items.unit_price = items.unit_price/100
            return items;
          });
          if (!this.tableData.length && this.page_no !== 0) {
            this.page_no = 0;
            this.getTableData();
          }
          this.total = res.data.count;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //详细信息
    getEdit(index, row) {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_raw_platform_byid
      } else {
        baseUrl = this.$userList.user_dish_raw_byid
      }

      const url = baseUrl + '/' + row.id;
      console.log(url)

      this.$http.get(url).then(res => {
        if (res.code === 200) {
          res.data.getEdit = true;
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.unit_price = res.data.unit_price/100
          this.form = res.data;
          this.dialogFormVisible = true;
          this.putStatus = true;
          return;
        }
        if (res.code !== 200) {
          this.$alert('获取详细信息失败');
        }
      });
      console.log(index, row);
    },
    //打开编辑弹窗
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.putStatus = true;
      // row.unit_price = row.unit_price/100
      this.form = row;
      console.log(index, row);
    },
    //删除
    handleDelete(index, row) {
      console.log(index, row);
      this.$confirm('此操作将删除此原材料, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {

        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_dish_raw_platform_create
        } else {
          baseUrl = this.$userList.user_dish_raw_create
        }

        const url = baseUrl + '/' + row.id;

        this.$http.delete(url).then(res => {
          if (res.code === 200) {
            this.getTableData();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除单位失败');
          }
        });
      });
    },
    // 取消
    noStatus() {
      this.dialogFormVisible = false;
      if (this.form.getEdit || !this.putStatus) {
        return;
      }
    },
    setForm() {
      this.form = {
        name: '',
      };
    },
    onSubmit() {
      this.dialogFormVisible = true;
      this.putStatus = false;
      this.setForm();
    },
    statusStore() {
      if (this.form.getEdit) {
        this.dialogFormVisible = false;
        return;
      }
      if (!this.putStatus) {
        this.setStore();
      } else {
        this.putDtore();
      }
    },
    setStore() {
      console.log(this.form);
      if (!this.form.name) {
        this.$alert('名称不能为空');
        return;
      }
      if (!+this.form.unit_price && + this.form.unit_price !== 0) {
        this.$alert('参数错误，单价只能为数字');
        return;
      }

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_raw_platform_create
      } else {
        baseUrl = this.$userList.user_dish_raw_create
      }

      const data = {
        name: this.form.name,
        category: this.form.category,
        unit: this.form.unit,
        unit_price: parseFloat(this.form.unit_price) * 100 ,
        calorie:  parseFloat(this.form.calorie),
        fat: parseFloat(this.form.fat),
        carbohydrate:  parseFloat(this.form.carbohydrate),
        protein:  parseFloat(this.form.protein),
        oil:  parseFloat(this.form.oil),
        salt:  parseFloat(this.form.salt),
        sugar:  parseFloat(this.form.sugar),
        na:  parseFloat(this.form.na),
      };
      this.$http.post(baseUrl, data).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('新增原料失败');
        }
        console.log(res);
      });
    },
    putDtore() {
      if (!this.form.name) {
        this.$alert('名称不能为空');
        return;
      }
      if (!+this.form.unit_price && +this.form.unit_price !== 0) {
        this.$alert('参数错误，数量只能为数字');
        return;
      }

      const data = {
        id: this.form.id,
        name: this.form.name,
        category: this.form.category,
        unit: this.form.unit,
        unit_price: parseFloat(this.form.unit_price) * 100 ,
        calorie:  parseFloat(this.form.calorie),
        fat: parseFloat(this.form.fat),
        carbohydrate:  parseFloat(this.form.carbohydrate),
        protein:  parseFloat(this.form.protein),
        oil:  parseFloat(this.form.oil),
        salt:  parseFloat(this.form.salt),
        sugar:  parseFloat(this.form.sugar),
        na:  parseFloat(this.form.na),
      };

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_raw_platform_create
      } else {
        baseUrl = this.$userList.user_dish_raw_create
      }

      this.$http.put(baseUrl, data).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.$alert('修改原料成功');
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('修改原料失败');
        }
      });
    },
  },
  created() {
    let platform = this.$route.query.platform
    console.log("platform is :", platform)
    this.platform = platform
    this.$root.setheadName();
    this.getTableData();
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: auto;
  position: relative;
}
.banner_bar {
  width: 100%;
  height: auto;
  background: #fff;
  min-height: 800px;
  box-sizing: border-box;
  padding: 20px;
}
.top_button {
  width: 100%;
  min-height: 300px;
  display: flex;
}
.button_a {
  width: 300px;
  height: auto;
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-right: 50px;
  margin-bottom: 50px;
}
.button_top {
  width: 100%;
  height: 64px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
}
.button_push {
  width: 63px;
  height: 32px;
  background: #1890ff;
  color: #fff;
  text-align: center;
  line-height: 32px;
  border-radius: 10px;
}
.banner_ul {
  width: 100%;
  height: auto;
}
.banner_ul li {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 40px;
}
.li_icon i {
  margin-right: 10px;
  width: 16rpx !important;
  height: 16rpx !important;
}
.colorli {
  background: rgba(127, 125, 243, 0.3);
}
.bottoms {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  height: 100%;
  height: 20px;
}
</style>
